/* eslint-disable operator-assignment */
import * as types from './types';
import { selectedLead, selectedRowOption, setData } from './utils';

function crossTableReducer(state, action) {
  switch (action.type) {
    case types.UNSELECTED_ALL_LEADS:
      state.table.leads = state.table.leads.map(l => {
        l.isSelected = false;
        return l;
      });
      state.filterTable.checkedStatus = selectedRowOption(state.table.leads);
      return { ...state };
    case types.SELECTED_LEAD:
      state.table.leads = selectedLead(action.payload, state.table.leads);
      state.filterTable.checkedStatus = selectedRowOption(state.table.leads);
      return { ...state };
    case types.UPDATE_LEADS_IN_BACKGROUND_SUCCEEDED:
      state.table = {
        ...state.table,
        params: { ...state.table.params, offset: action.payload.paging.offset },
        leads: setData(action.payload.result),
        paging: action.payload.paging
      };
      state.filterTable.checkedStatus = selectedRowOption(state.table.leads);
      return { ...state };
    case types.UPDATE_LEADS_STATUS_SUCCEEDED_MOBILE:
      state.table.paging.total = state.table.paging.total - action.payload.contactIds.length;
      if (state.filterStatus.filtersSelected.length > 0) {
        state.filterStatus.filtersTotalState -= action.payload.contactIds.length;
      }
      action.payload.contactIds.forEach(id => {
        const foundedIndex = state.table.leads.findIndex(lead => lead.contact_publisher_user_id === id);
        state.table.leads.splice(foundedIndex, 1);
      });
      return { ...state };
    default:
      return { ...state };
  }
}

export default crossTableReducer;
